export const Strings = {
  password: ' ',
  mapLink: "To embed a Google Maps location: Go to Google Maps, select a location, click \\'Share\\', then \\'Embed a map\\'. Copy the URL from the \\'src\\' attribute inside the \\'<iframe>\\' snippet, starting with \\'https://www.google.com/maps/embed?pb=\\'. Paste this URL to display the map.",
}